import BreakdownHOK from 'components/Pages/FundsCenter/FundDetails/FirstLevelTabs/FundDetailsBreakdownTab/BreakdownHOK';

const FundDetailsCorrelationMatrixTab = () => {
  return (
    <div className="container">
      <BreakdownHOK
        endpoint="correlationMatrix"
        minimal
        applyScroll
        showFromToDate
        wrapperId="correlationMatrixWrapper"
        tableId="correlationMatrixTable"
        titleKey="fundDetailsBreakdownCorrelationMatrixTitle"
      />
    </div>
  );
};

export default FundDetailsCorrelationMatrixTab;
